import { $4, $$4, formatMoney } from "@theme/utilities";
/* Vitarights: converted prices show whole numbers + currency code only (e.g. "604 AED").
   KWD always shows the store's own price (the real checkout price). */
var newCurrency = null,
  cartCurrency = Shopify.currency.active,
  shopCurrency = themeHDN.settings.shopCurency,
  t_moneyFormat = themeHDN.settings.currencyFormat,
  selector = ".hdt-popover-currencies",
  dt_cur_shop = 'currency' + cartCurrency.charAt(0) + cartCurrency.slice(1).toLowerCase(),
  dt_base = 'baseCurrency',
  rate = parseFloat(Shopify.currency.rate);
var CurrencyConfigs = {
  currentCurrency: localStorage.getItem('hdt_currency_iso') || null,
  format: 'money_with_currency_format'
};
var arrayCurrency = {
  KW: "KWD", AE: "AED", SA: "SAR", QA: "QAR", BH: "BHD", OM: "OMR",
  US: "USD", GB: "GBP",
  DE: "EUR", FR: "EUR", IT: "EUR", ES: "EUR", NL: "EUR", BE: "EUR", AT: "EUR",
  IE: "EUR", PT: "EUR", FI: "EUR", GR: "EUR", LU: "EUR"
};
function codeOnly(code) {
  var f = "{{amount_no_decimals}} " + code;
  return { money_format: f, money_with_currency_format: f };
}
var moneyFormats = {
  KWD: { money_format: "{{amount}} KWD", money_with_currency_format: "{{amount}} KWD" },
  AED: codeOnly("AED"), SAR: codeOnly("SAR"), QAR: codeOnly("QAR"),
  BHD: codeOnly("BHD"), OMR: codeOnly("OMR"),
  USD: codeOnly("USD"), EUR: codeOnly("EUR"), GBP: codeOnly("GBP")
};

function baseCurrency(el) {
  var newFormat = (moneyFormats[shopCurrency] || {})[CurrencyConfigs.format] || '{{amount}}';
  let baseAmount = el.textContent;
  if (t_moneyFormat.indexOf('with_comma_separator') !== -1) {
    baseAmount = baseAmount.replace(/[,.]/g, function (match) { return match === ',' ? '.' : ','; });
  }
  let cents = parseFloat(baseAmount.replace(/^[^0-9]+|[^0-9.]/g, ''), 10) * 100 / rate;
  // Guard against double conversion: if this text is already in another currency, convert it back first.
  var shown = Object.keys(moneyFormats).find(function (c) { return c !== shopCurrency && baseAmount.indexOf(c) !== -1; });
  if (shown) cents = Currency.convert(cents * rate, shown, shopCurrency);
  el.dataset[dt_base] = cents;
  el.setAttribute("data-currency-" + shopCurrency.toLowerCase(), formatMoney(cents, newFormat));
  return cents;
}

function CurrencyConvertAll(newCurrency, selector) {
  if (!newCurrency || !moneyFormats[newCurrency]) { return false }
  const $selector = $$4(selector || `.hdt-money:not([no-select-money],[data-hdt-currency="${newCurrency}"])`);
  var newFormat = moneyFormats[newCurrency][CurrencyConfigs.format];
  $selector.forEach(function (el) {
    if (!el.dataset[dt_cur_shop]) el.dataset[dt_cur_shop] = el.textContent;
    const baseAmount = el.dataset[dt_base] ? parseFloat(el.dataset[dt_base]) : baseCurrency(el);
    if (typeof baseAmount === 'undefined' || isNaN(baseAmount)) return;
    let newCurrencyData = 'currency' + newCurrency.charAt(0) + newCurrency.slice(1).toLowerCase();
    if (el.dataset[newCurrencyData]) {
      el.innerHTML = el.dataset[newCurrencyData];
    } else {
      let newCents = Currency.convert(baseAmount, shopCurrency, newCurrency);
      newCents = Math.round(newCents / 100) * 100;
      const newFormattedAmount = formatMoney(newCents, newFormat);
      el.innerHTML = newFormattedAmount;
      el.dataset[newCurrencyData] = newFormattedAmount;
    }
    el.dataset['hdtCurrency'] = newCurrency;
  });
}

function buildFromData(data) {
  const currencyCode = arrayCurrency[data.country] || cartCurrency;
  $$4(selector).forEach(function (el) {
    const auto = el.querySelector('.hdt-item-auto');
    if (moneyFormats[currencyCode] && el.querySelector('button[value="' + currencyCode + '"]:not(.hdt-item-auto)') == null && auto) {
      auto.setAttribute('value', currencyCode);
      auto.setAttribute('data-name', currencyCode);
      const img = auto.querySelector('img');
      if (img) {
        img.setAttribute("src", "//cdn.shopify.com/static/images/flags/" + currencyCode.slice(0, 2).toLowerCase() + ".svg");
        img.setAttribute("alt", currencyCode);
      }
      auto.querySelector('span').innerHTML = currencyCode;
      auto.classList.remove('wait');
    } else if (auto) {
      auto.remove();
    }
  });
  const pick = CurrencyConfigs.currentCurrency || (moneyFormats[currencyCode] ? currencyCode : cartCurrency);
  $$4(selector + " hdt-richlist").forEach(function (el) {
    el.setAttribute("selected", pick);
  });
}

function fetchIpinfo() {
  fetch('https://ipinfo.io/json', { method: 'GET' })
    .then(function (response) { return response.json() })
    .then(function (data) {
      buildFromData(data);
      localStorage.setItem('hdt_currency', JSON.stringify(data));
    }).catch(error => console.error('Error ipinfo:', error));
}

function init() {
  if (!$4(`${selector}`)) return;
  if (!themeHDN.settings.autoCurrencies || navigator.userAgent.match(/bot|spider/i)) {
    if (CurrencyConfigs.currentCurrency && CurrencyConfigs.currentCurrency != cartCurrency) {
      $4(`${selector} button[value="${CurrencyConfigs.currentCurrency}"]`)?.click();
    }
    $4(`${selector} .hdt-item-auto.wait`)?.remove();
    return;
  }
  var nt_currency = localStorage.getItem('hdt_currency');
  if (nt_currency) {
    buildFromData(JSON.parse(nt_currency));
  } else {
    fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json', { method: 'GET' })
      .then(function (response) { return response.json() })
      .then((data) => {
        try {
          const country = data.detected_values.country.handle;
          data = { country };
          buildFromData(data);
          localStorage.setItem('hdt_currency', JSON.stringify(data));
        } catch (error) {
          fetchIpinfo();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        fetchIpinfo();
      });
  }
}

document.addEventListener("richlist:change", (e) => {
  if (e.target.name === "country_code" && e.detail.value !== newCurrency) {
    localStorage.setItem('hdt_currency_iso', e.detail.value);
    $$4('[data-flag-current]').forEach(function (el) {
      el.setAttribute("src", "//cdn.shopify.com/static/images/flags/" + e.detail.value.slice(0, 2).toLowerCase() + ".svg");
      el.removeAttribute("srcset");
      el.setAttribute("alt", e.detail.value);
    });
    $$4('[data-name-current]').forEach(function (el) {
      el.innerHTML = e.detail.value;
    });
    newCurrency = e.detail.value;
    CurrencyConvertAll(e.detail.value);
  }
});
document.addEventListener("currency:update", () => CurrencyConvertAll(newCurrency));
document.addEventListener("products:update", () => CurrencyConvertAll(newCurrency));

init();
$4('hdt-lazy-html[section-id="popover-currencies"]')?.addEventListener('lazyhtml:added', () => {
  init();
});
